/* eslint-disable no-unused-expressions */
import Cookie from 'js-cookie';
import React, { Component } from 'react';
import axios from 'axios';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Helmet } from 'react-helmet';
import { Config } from '../../config/config';
import UploadDocDialog from './Dialogs/UploadDocDialog';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import Spinner from '../../UIComponents/Spinner/Spinner';
import { Navigate } from 'react-router-dom';
import ArchiveDialog from './Dialogs/ArchiveDialog';
import IconButton from '@mui/material/IconButton';
import LZString from 'lz-string';

/* import {
  COMPLIANCE_DOCUMENTS,
  CONTRACT_DOCUMENTS,
} from './ComplianceAndContract'; */
import {
  //MAINTENANCE_DOCUMENTS,
  DOCUMENT_PATH,
  DOCUMENT_EDIT,
} from './MaintenanceDoc';
import Footer from '../Footer';
import Header from '../Header';
import Menu from '../Menu';
import './Dialogs/dialog.css';
import MessageBoxForInvalidPage from '../../UIComponents/MessageBox/MessageBoxForInvalidPage';

class SafetyRegister extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    let storeid;
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    let stores = JSON.parse(localStorage.getItem('storeData')).sort((a, b) =>
      a.storeName > b.storeName ? 1 : -1
    );

    let wareHouses = JSON.parse(localStorage.getItem('warehouseData')).sort(
      (a, b) => (a.storeName > b.storeName ? 1 : -1)
    );
    let curStore = localStorage.getItem('curStoreID');
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();

    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const userInfo = JSON.parse(decompressedData) 
    const menu = userInfo['moduleAccess'];
    let userID = userInfo['userId'];
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');

    this.state = {
      title: 'Safety Register',
      userID,
      alert: '',
      incType: '',
      storeValue: curStore ? curStore : stores.length>0?stores[0].storeId:wareHouses[0].storeId,
      //storeValue: '',
      closure: '',
      stores,
      wareHouses,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      temp: 0,
      temp1: 0,
      FromDate: dateString,
      date: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      data: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      activeTab: '',
      storeid: curStore ? curStore : stores.length>0?stores[0].storeId: wareHouses[0].storeId,
      tempTab: null,
      redirect: false,
      red: false,
      redirectLink: '',
      load: false,
      user: menu,
      pageAllowed: false,
      tab1: false,
      tab2: false,
      uploadEditing: false,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleStoreValue = (e) => {
    this.setState({
      storeid: e.target.value,
      storeValue: e.target.value,
      redirect: false,
    });
    //  alert(e.target.value);
    localStorage.setItem('curStoreID', e.target.value);

    this.handleSelect(this.state.activeTab, e.target.value);
  };

  fileDownload(documentPath) {
    this.setState({
      loading: true,
    });
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          this.state.apiInterface +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file

        const fileURL = URL.createObjectURL(file);

        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.setState({
          loading: false,
        });
      })
      .catch((error) => {});
  }
  handleDelete(documentId, index) {
    if (index === 0) {
      ApiGateWay.Post(
        this.state.apiInterface +
          '/deleteComplianceDocument?documentId=' +
          documentId
      )
        .then((response) => {
          window.location.reload();
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 1) {
      ApiGateWay.Post(
        this.state.apiInterface +
          '/deleteContractDocument?documentId=' +
          documentId
      )
        .then((response) => {
          window.location.reload();
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  }

  handleSelect = (index, id) => {
    localStorage.setItem('tabName', index);

    //StoreID being set, Initially when nothing is selected, it will display "Sarjapura, 3 storeID"
    // if (id === undefined) {
    //   id = 3;
    // }
    this.setState({
      activeTab: index,
      loading: true,
      storeid: id,
    });

    //Active Tab 0=Compliance, 1= Contracts, 2= Maintenance

    if (index === 0) {
      ApiGateWay.PostEmp(
        this.state.apiInterface + '/loadComplianceAndContractList?storeId=' + id
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(JSON.stringify(response.tbody));
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          this.setState({
            loading: false,
            tab1: true,
            tab2: false,
            temp: response.compliance[0].score,
          });

          let body = [];
          let colorCodes = [];
          let proxyjson = [];
          let exp;
          let status = response.compliance[0].score;
          response.compliance[0].documentTypes.map((name, val) => {
            exp = name.expiryDate;
            if (name.documentStatus === 'Yes') {
              body.push([
                val + 1,
                <a
                  onClick={() => this.fileDownload(name.documentPath)}
                  style={{ cursor: 'pointer' }}
                >
                  {name.documentType}
                </a>,
                exp,
                name.documentStatus,
                <ArchiveDialog
                  url='/loadComplianceListArchive'
                  storeId={id}
                  documentId={name.documentTypeId}
                />,
                <IconButton
                  onClick={() => this.handleDelete(name.documentId, 0)}
                  style={{ color: ' #a94442' }}
                >
                  <i className='fas fa-trash'></i>
                </IconButton>,
              ]);
            } else
              body.push([
                val + 1,
                name.documentType,
                exp,
                name.documentStatus,
                <ArchiveDialog
                  url='/loadComplianceListArchive'
                  storeId={id}
                  documentId={name.documentTypeId}
                />,
                '',
              ]);
            colorCodes.push([0, 0, 0, 0, 0, 0]);
          });
          let proxyjson1 = {
            type: 'Compliance',
            thead: [
              'SlNo',
              'Document Name',
              'Expiry Date',
              'Document Status',
              'Archive',
              'Delete',
            ],
            tbody: body,
            columns: [
              'SlNo',
              'Document Name',
              'Expiry Date',
              'Document Status',
              'Archive',
              'Delete',
            ],
            colorCodes: colorCodes,
            status: status,
          };
          this.setState({
            loading: false,
            proxyjson: proxyjson1,
            temp: response.compliance[0].score,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 1) {
      ApiGateWay.PostEmp(
        this.state.apiInterface + '/loadComplianceAndContractList?storeId=' + id
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          this.setState({
            loading: false,
            tab2: true,
            tab1: false,
            temp1: response.contracts[0].score,
          });
          let body = [];
          let colorCodes = [];
          let proxyjson = [];
          let sDate;
          let eDate;
          let status = response.contracts[0].score;
          response.contracts[0].documentTypes.map((name, val) => {
            sDate = name.startDate;
            eDate = name.expiryDate;
            if (name.documentStatus === 'Yes') {
              body.push([
                val + 1,
                <a
                  onClick={() => this.fileDownload(name.documentPath)}
                  style={{ cursor: 'pointer' }}
                >
                  {name.documentType}
                </a>,
                name.documentStatus,
                name.vendorName,
                sDate,
                eDate,
                <ArchiveDialog
                  url='/loadContractListArchive'
                  storeId={id}
                  documentId={name.documentTypeId}
                  docName={name.documentType}
                />,
                <IconButton
                  onClick={() => this.handleDelete(name.documentId, 1)}
                  style={{ color: ' #a94442' }}
                >
                  <i className='fas fa-trash'></i>
                </IconButton>,
              ]);
            } else
              body.push([
                val + 1,
                name.documentType,
                name.documentStatus,
                name.vendorName,
                sDate,
                eDate,
                <ArchiveDialog
                  url='/loadContractListArchive'
                  storeId={id}
                  documentId={name.documentTypeId}
                />,
                '',
              ]);
            colorCodes.push([0, 0, 0, 0, 0, 0]);
          });
          let proxyjson2 = {
            type: 'Contracts',
            thead: [
              'SlNo',
              'Document Name',
              'Document Status',
              'Vendor Name',
              'Contract Start Date',
              'Expiry Date',
              'Archive',
              'Delete',
            ],
            tbody: body,
            columns: [
              'SlNo',
              'Document Name',
              'Document Status',
              'Vendor Name',
              'Contract Start Date',
              'Expiry Date',
              'Archive',
              'Delete',
            ],
            colorCodes: colorCodes,
            status: status,
          };
          this.setState({
            loading: false,
            proxyjson: proxyjson2,
            temp1: response.compliance[0].score,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 2) {
      ApiGateWay.Post(
        this.state.apiInterface + '/loadMaintenanceDocuments?storeId=' + id
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          let body = [];
          let colorCodes = [];
          let proxyjson = [];
          response.maintenaceDocuments.map((name, val) => {
            body.push([val + 1, name.documentType, '', '']);
            if (name.documents) {
              name.documents.forEach((element) => {
                body.push([
                  '',
                  <a
                    onClick={() => this.fileDownload(element.documentPath)}
                    style={{ cursor: 'pointer' }}
                  >
                    {element.documentName}
                  </a>,
                  element.uploadedDate,
                  element.uploadedBy,
                ]);
              });
            }
            colorCodes.push([0, 0, 0, 0, 0, 0]);
          });
          let proxyjson3 = {
            type: 'Compliance',
            thead: ['SlNo', 'Equipment Name', 'Upload Date', 'Upload By'],
            tbody: body,
            columns: ['SlNo', 'Equipment Name', 'Upload Date', 'Upload By'],
            colorCodes: colorCodes,
          };

          this.setState({
            proxyjson: proxyjson3,
            loading: false,
            temp: 0,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 3) {
      this.setState({
        loading: false,
      });
    }
  };
  handleClick = () => {
    this.setState({
      load: true,
    });

    DOCUMENT_PATH('/safetyregisterpath', this.state.storeid)
      .then((response) => {
        this.setState({
          redirectLink: response,
          redirect: true,
          load: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          load: false,
          message: 'Unable to retrieve the data. Please try again later',
          activeTab: 0,
        });
      });
  };

  handleSRLog = () => {
    let logData = {
      appType: 'Web',
      employeeId: this.state.userID,
      storeId: this.state.storeid,
      viewMode: 'Edit',
    };

    DOCUMENT_EDIT('/safetyrigisterlog', logData)
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        if (response.status === 'Success') {
          this.setState({
            red: true,
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          load: false,
          message: 'Unable to retrieve the data. Please try again later',
          activeTab: 0,
        });
      });
  };

  setUploadEditing = (edor) => {
    this.setState({
      uploadEditing: edor,
    });

    let m = localStorage.getItem('tabName');
    if (this.state.uploadEditing) {
      this.handleSelect(parseInt(m), this.state.storeValue);
    }
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Safety Register'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      let m = localStorage.getItem('tabName');

      this.setState({
        tempTab: m,
        loading: true,
      });

      setTimeout(() => {
        this.handleSelect(
          parseInt(m) ? parseInt(m) : 0,
          this.state.storeValue
            ? this.state.storeValue
            : localStorage.getItem('curStoreID')
        );
      }, 2000);
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }

  render() {
    const { loading, modalOpen, message, storeid, pageAllowed } = this.state;
    var ToDate = new Date();
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? !val.featureAccess
              ? val.featureName == 'Safety Register'
                ? (pageAllow = true)
                : ''
              : ''
            : ''
        )}
        {pageAllow === false ? (
         
          <Navigate to="/pageNotAllowed" state={{ id:'Safety Register'}} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>

        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={'Safety Register'} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row'>
                  <div className='col-md-2 col-lg-2 col-sm-2'>
                    <form style={{ background: 'none', padding: 'none' }}>
                      <div
                        className='form-group'
                        style={{ marginLeft: '-8px', marginTop: '-10px' }}
                      >
                        <select
                          className='form-control EvacInput'
                          value={this.state.storeid}
                          onChange={this.handleStoreValue}
                        >
                          <option disabled value=''>
                            Select a Store
                          </option>
                          {this.state.stores
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                          {this.state.wareHouses
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </form>
                  </div>
                </div>
                <br /> <br />
                {loading ? (
                  <Spinner />
                ) : (
                  <div
                    className='nav-tabs-custom'
                    style={{ marginTop: '-40px ' }}
                  >
                    <ul className='nav nav-tabs' id=''>
                      <li
                        className={this.state.activeTab === 0 ? 'active' : ''}
                        onClick={() => this.handleSelect(0, this.state.storeid)}
                      >
                        <a href='#tab_1' data-toggle='tab'>
                          Compliance
                        </a>
                      </li>
                      <li
                        className={this.state.activeTab === 1 ? 'active' : ''}
                        onClick={() => this.handleSelect(1, this.state.storeid)}
                      >
                        <a href='#tab_2' data-toggle='tab'>
                          Contracts
                        </a>
                      </li>
                      <li
                        className={this.state.activeTab === 2 ? 'active' : ''}
                        onClick={() => this.handleSelect(2, this.state.storeid)}
                      >
                        <a href='#tab_3' data-toggle='tab'>
                          Maintenance Documents
                        </a>
                      </li>
                      <li
                        className={this.state.activeTab === 3 ? 'active' : ''}
                        onClick={() => this.handleSelect(3, this.state.storeid)}
                      >
                        <a href='#tab_4' data-toggle='tab'>
                          Safety Register
                        </a>
                      </li>
                    </ul>
                    <div className='tab-content'>
                      <div
                        className={
                          `tab-pane ${this.state.activeTab === 0}`
                            ? `active`
                            : ''
                        }
                        id='tab_1'
                      >
                        <div className='row DataGridMain'>
                          <div className='col-md-8'>
                            {this.state.activeTab === 0 ? (
                              <div>
                                {this.state.tab1 ? (
                                  <ProgressBar
                                    animated
                                    now={this.state.proxyjson.status}
                                    label={`${this.state.proxyjson.status}%`}
                                  />
                                ) : (
                                  ''
                                )}

                                <table
                                  className='table table-bordered table-striped mainGrid safetyTable'
                                  id='DataGrid'
                                >
                                  <thead
                                    style={{
                                      background: 'rgb(60, 141, 188)',
                                      color: '#fff',
                                    }}
                                  >
                                    <tr>
                                      {this.state.proxyjson.thead
                                        ? this.state.proxyjson.thead.map(
                                            (val, index) => (
                                              <th key={val + index}>{val} </th>
                                            )
                                          )
                                        : null}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.proxyjson.tbody
                                      ? this.state.proxyjson.tbody.map(
                                          (data2, ind) => {
                                            return (
                                              <tr
                                                key={data2 + ind}
                                                style={{
                                                  background:
                                                    new Date(
                                                      data2[2]
                                                        .toString()
                                                        .split('/')
                                                        .reverse()
                                                        .join('-')
                                                    ) < new Date()
                                                      ? '#ffd9d5'
                                                      : '',
                                                }}
                                              >
                                                {data2.map((data3) => (
                                                  <td>{data3}</td>
                                                ))}
                                              </tr>
                                            );
                                          }
                                        )
                                      : null}
                                  </tbody>
                                </table>
                                <UploadDocDialog
                                  index={this.state.activeTab + 1}
                                  storeId={this.state.storeid}
                                  setUploadEditing={this.setUploadEditing}
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                        <br />
                        <br />
                      </div>
                      <div
                        className={
                          `tab-pane ${this.state.activeTab === 1}`
                            ? `active`
                            : ''
                        }
                        id='tab_2'
                      >
                        <div className='row'>
                          <div
                            className='col-md-8 DataGridMain'
                            style={{ marginTop: '-40px' }}
                          >
                            {this.state.activeTab === 1 ? (
                              <div>
                                {this.state.tab2 ? (
                                  <ProgressBar
                                    animated
                                    now={this.state.proxyjson.status}
                                    label={`${this.state.proxyjson.status}%`}
                                  />
                                ) : (
                                  ''
                                )}

                                <table
                                  className='table table-bordered table-striped mainGrid'
                                  id='DataGrid'
                                >
                                  <thead
                                    style={{
                                      background: 'rgb(60, 141, 188)',
                                      color: '#fff',
                                    }}
                                  >
                                    <tr>
                                      {this.state.proxyjson.thead
                                        ? this.state.proxyjson.thead.map(
                                            (val, index) => (
                                              <th key={val + index}>{val} </th>
                                            )
                                          )
                                        : null}
                                    </tr>
                                  </thead>
                                  <tbody
                                    style={{
                                      textAlign: 'left',
                                    }}
                                  >
                                    {this.state.proxyjson.tbody
                                      ? this.state.proxyjson.tbody.map(
                                          (data2, ind) => {
                                            return (
                                              <tr
                                                key={data2 + ind}
                                                style={{
                                                  background:
                                                    new Date(
                                                      data2[5]
                                                        ? data2[5]
                                                            .toString()
                                                            .split('/')
                                                            .reverse()
                                                            .join('-')
                                                        : ''
                                                    ) < new Date()
                                                      ? '#ffd9d5'
                                                      : '',
                                                }}
                                              >
                                                {data2.map((data3) => (
                                                  <td>{data3}</td>
                                                ))}
                                              </tr>
                                            );
                                          }
                                        )
                                      : null}
                                  </tbody>
                                </table>
                                <div>
                                  <UploadDocDialog
                                    index={this.state.activeTab + 1}
                                    storeId={this.state.storeid}
                                    setUploadEditing={this.setUploadEditing}
                                  />
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className='col-md-2'></div>
                        </div>
                        <br />
                        <br />
                      </div>
                      <div
                        className={
                          `tab-pane ${this.state.activeTab === 2}`
                            ? `active`
                            : ''
                        }
                        id='tab_3'
                      >
                        <div className='row'>
                          <div
                            className='col-md-8 DataGridMain'
                            style={{ marginTop: '-77px' }}
                          >
                            {this.state.activeTab === 2 ? (
                              <div>
                                <table
                                  className='table table-bordered table-striped mainGrid'
                                  id='DataGrid'
                                >
                                  <thead
                                    style={{
                                      background: 'rgb(60, 141, 188)',
                                      color: '#fff',
                                    }}
                                  >
                                    <tr>
                                      {this.state.proxyjson.thead
                                        ? this.state.proxyjson.thead.map(
                                            (val, index) => (
                                              <th key={val + index}>{val} </th>
                                            )
                                          )
                                        : null}
                                    </tr>
                                  </thead>
                                  <tbody
                                    style={{
                                      textAlign: 'left',
                                    }}
                                  >
                                    {this.state.proxyjson.tbody
                                      ? this.state.proxyjson.tbody.map(
                                          (data2, ind) => {
                                            return (
                                              <tr key={data2 + ind}>
                                                {data2.map((data3) => (
                                                  <td>{data3}</td>
                                                ))}
                                              </tr>
                                            );
                                          }
                                        )
                                      : null}
                                  </tbody>
                                </table>
                                <UploadDocDialog
                                  index={this.state.activeTab + 1}
                                  storeId={this.state.storeid}
                                  setUploadEditing={this.setUploadEditing}
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className='col-md-2'></div>
                        </div>
                        <br />
                        <br />
                      </div>
                      <div
                        className={
                          `tab-pane ${this.state.activeTab === 3}`
                            ? `active`
                            : ''
                        }
                        id='tab_4'
                      >
                        {this.state.activeTab === 3 ? (
                          <div className='row'>
                            <div
                              className='col-md-8'
                              style={{ marginTop: '-100px' }}
                            >
                              {this.state.load ? (
                                <Spinner />
                              ) : this.state.redirect ? (
                                this.state.redirectLink !== null ? (
                                  <a
                                    className='deca-btn-yellow'
                                    href={this.state.redirectLink}
                                    target={'_blank'}
                                    onClick={this.handleSRLog}
                                  >
                                    View Document{' '}
                                  </a>
                                ) : (
                                  <p>{'No Document Link Found'}</p>
                                )
                              ) : (
                                <>
                                  <button
                                    className='deca-btn-yellow'
                                    onClick={this.handleClick}
                                  >
                                    {' '}
                                    Load Document Link{' '}
                                  </button>
                                </>
                              )}
                            </div>
                            <div className='col-md-2'></div>
                          </div>
                        ) : (
                          ''
                        )}
                        <br />
                        <br />
                      </div>
                    </div>
                  </div>
                )}
              </section>
            )}
          </div>
          <Footer />
        </div>
      </>
    );
  }
}

export default SafetyRegister;
